// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QJA1","title":"styles_title__3AgB3"};